import { assign } from '../utils/lodash';
import { setValue } from '../utils/localStorage';

const developmentEnv = 'qa2';
const enableTempGeneratorTokenUrl = true;

const development = {
  api: 'https://enlighten-rel.enphaseenergy.com',
  enlighten_url: 'https://enlighten-rel.enphaseenergy.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  permitting_url: 'https://permit-stg.enphaseenergy.com',
  sgip_url: 'https://sgip-stg.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  estimator_appliances_url:
    'https://qa2.enphaseenergy.com/estimator/advanced-appliances',
  solargraf_url: 'https://staging.solargraf.com',
  solargraf_api_url: 'https://api-staging.solargraf.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  activation_url: 'https://activations-ui-dev.enphaseenergy.com',
  drsUrl: 'https://drs-api-stg.enphaseenergy.com',
  training_dashboard_url: 'https://dashboard-training-dev.qa-enphaseenergy.com',
  bom_ui_url: 'https://bom-stg.enphaseenergy.com',
  bom_api_url: 'https://bom-api-stg.enphaseenergy.com',
  notificationPreferenceUrl:
    'https://enlighten-rel.enphaseenergy.com/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementstg.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-stg.qa-enphaseenergy.com',
  temp_generator_token_url: 'https://generator-token-service.enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-stg.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const test = {
  api: 'https://enlighten-qa4.enphaseenergy.com',
  enlighten_url: 'https://enlighten-qa4.enphaseenergy.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  permitting_url: 'https://permit-stg.enphaseenergy.com',
  sgip_url: 'https://sgip-stg.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  estimator_appliances_url:
    'https://qa2.enphaseenergy.com/estimator/advanced-appliances',
  solargraf_url: 'https://app-develop.solargraf.com',
  solargraf_api_url: 'https://api-develop.solargraf.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  drsUrl: 'https://drs-api-stg.enphaseenergy.com',
  training_dashboard_url: 'https://dashboard-training-dev.qa-enphaseenergy.com',
  bom_ui_url: 'https://bom-stg.enphaseenergy.com',
  bom_api_url: 'https://bom-api-stg.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementdev.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-dev.qa-enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-dev.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const qa2 = {
  api: '',
  enlighten_url: '',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  permitting_url: 'https://permit-stg.enphaseenergy.com',
  sgip_url: 'https://sgip-stg.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  estimator_appliances_url: '/estimator/advanced-appliances',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  activation_url: 'https://activations-ui-qa.enphaseenergy.com',
  drsUrl: 'https://drs-api-stg.enphaseenergy.com',
  training_dashboard_url: '/app/training_dashboard',
  bom_ui_url: 'https://bom-stg.enphaseenergy.com',
  bom_api_url: 'https://bom-api-stg.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementstg.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-stg.qa-enphaseenergy.com',
  temp_generator_token_url: 'https://generator-token-service.enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-stg.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const qa4 = {
  api: '',
  enlighten_url: '',
  digital_core_url: 'https://dc-dev.enphaseenergy.com',
  permitting_url: 'https://permit-dev.enphaseenergy.com',
  sgip_url: 'https://sgip-dev.enphaseenergy.com',
  ein_core_url: 'https://eincore-dev.enphaseenergy.com',
  estimator_appliances_url:
    'https://qa2.enphaseenergy.com/estimator/advanced-appliances',
  solargraf_url: 'https://app-develop.solargraf.com',
  solargraf_api_url: 'https://api-develop.solargraf.com',
  drs_ui_url: 'https://drs-dev.enphaseenergy.com',
  activation_url: 'https://activations-ui-dev.enphaseenergy.com',
  drsUrl: 'https://drs-api-dev.enphaseenergy.com',
  training_dashboard_url: 'https://dashboard-training-dev.qa-enphaseenergy.com',
  bom_ui_url: 'https://bom-dev.enphaseenergy.com',
  bom_api_url: 'https://bom-api-dev.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementdev.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-dev.qa-enphaseenergy.com',
  temp_qa4_generator_url: 'https://token-generator-ms-dev.qa-enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-dev.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const cotqa4 = {
  api: 'https://enlighten-cotqa4.enphaseenergy.com',
  enlighten_url: 'https://enlighten-cotqa4.enphaseenergy.com',
  digital_core_url: 'https://dc-dev.enphaseenergy.com',
  permitting_url: 'https://permit-dev.enphaseenergy.com',
  sgip_url: 'https://sgip-dev.enphaseenergy.com',
  ein_core_url: 'https://eincore-dev.enphaseenergy.com',
  estimator_appliances_url:
    'https://qa2.enphaseenergy.com/estimator/advanced-appliances',
  solargraf_url: 'https://app-develop.solargraf.com',
  solargraf_api_url: 'https://api-develop.solargraf.com',
  drs_ui_url: 'https://drs-dev.enphaseenergy.com',
  activation_url: 'https://activations-ui-dev.enphaseenergy.com',
  drsUrl: 'https://drs-api-dev.enphaseenergy.com',
  training_dashboard_url: 'https://dashboard-training-dev.qa-enphaseenergy.com',
  bom_ui_url: 'https://bom-dev.enphaseenergy.com',
  bom_api_url: 'https://bom-api-dev.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementdev.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-dev.qa-enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-dev.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const preprod = {
  api: '',
  enlighten_url: '',
  digital_core_url: 'https://dc-preprod.enphaseenergy.com',
  permitting_url: 'https://permit.enphaseenergy.com',
  sgip_url: 'https://sgip-preprod.enphaseenergy.com',
  ein_core_url: 'https://ein-core-preprod.enphaseenergy.com',
  estimator_appliances_url:
    'https://enlighten.enphaseenergy.com/estimator/advanced-appliances',
  solargraf_url: 'https://app.solargraf.com',
  solargraf_api_url: 'https://api.solargraf.com',
  drs_ui_url: 'https://drs-preprod.enphaseenergy.com',
  drsUrl: 'https://drs-api-preprod.enphaseenergy.com',
  activation_url:
    'https://enlighten-preprod.enphaseenergy.com/app/activation_ui',
  training_dashboard_url: '/app/training_dashboard',
  bom_ui_url: 'https://bom-preprod.enphaseenergy.com',
  bom_api_url: 'https://bom-api-preprod.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacement-preprod.enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-preprod.enphaseenergy.com',
  temp_generator_token_url: 'https://generator-token-service.enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-preprod.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const production = {
  api: '',
  enlighten_url: '',
  digital_core_url: 'https://dc.enphaseenergy.com',
  permitting_url: 'https://permit.enphaseenergy.com',
  sgip_url: 'https://sgip.enphaseenergy.com',
  ein_core_url: 'https://ein-core.enphaseenergy.com',
  estimator_appliances_url: 'estimator/advanced-appliances',
  solargraf_url: 'https://app.solargraf.com',
  solargraf_api_url: 'https://api.solargraf.com',
  drs_ui_url: 'https://drs.enphaseenergy.com',
  drsUrl: 'https://drs-api.enphaseenergy.com',
  activation_url: 'https://activations-ui.enphaseenergy.com',
  training_dashboard_url: '/app/training_dashboard',
  bom_ui_url: 'https://bom.enphaseenergy.com',
  bom_api_url: 'https://bom-api.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacement.enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard.enphaseenergy.com',
  temp_generator_token_url: 'https://generator-token-service.enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const dev = {
  api: 'https://enlighten-rel.enphaseenergy.com',
  enlighten_url: 'https://enlighten-rel.enphaseenergy.com',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  permitting_url: 'https://permit-stg.enphaseenergy.com',
  sgip_url: 'https://sgip-stg.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  estimator_appliances_url:
    'https://qa2.enphaseenergy.com/estimator/advanced-appliances',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  activation_url: 'https://activations-ui-qa.enphaseenergy.com',
  drsUrl: 'https://drs-api-stg.enphaseenergy.com',
  training_dashboard_url: 'https://training-dashboard-dev.enphaseenergy.com',
  bom_ui_url: 'https://bom-stg.enphaseenergy.com',
  bom_api_url: 'https://bom-api-stg.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementstg.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-stg.qa-enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-dev.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const stg = {
  api: '',
  enlighten_url: '',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  permitting_url: 'https://permit-stg.enphaseenergy.com',
  sgip_url: 'https://sgip-stg.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  estimator_appliances_url: 'estimator/advanced-appliances',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  activation_url: 'https://activations-ui-qa.enphaseenergy.com',
  drsUrl: 'https://drs-api-stg.enphaseenergy.com',
  training_dashboard_url: 'https://training-dashboard-stg.enphaseenergy.com',
  bom_ui_url: 'https://bom-stg.enphaseenergy.com',
  bom_api_url: 'https://bom-api-stg.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementstg.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-stg.qa-enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-stg.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const rel = {
  api: '',
  enlighten_url: '',
  digital_core_url: 'https://dc-stg.enphaseenergy.com',
  permitting_url: 'https://permit-stg.enphaseenergy.com',
  sgip_url: 'https://sgip-stg.enphaseenergy.com',
  ein_core_url: 'https://eincore-stg.enphaseenergy.com',
  estimator_appliances_url: 'estimator/advanced-appliances',
  //pointing to alpha for SG Pro integration test
  solargraf_url: 'https://alpha.solargraf.com', //'https://alpha.solargraf.com',
  solargraf_api_url: 'https://api-alpha.solargraf.com', //'https://api-staging.solargraf.com',
  drs_ui_url: 'https://drs-stg.enphaseenergy.com',
  activation_url: 'https://enlighten-rel.enphaseenergy.com/app/activation_ui',
  drsUrl: 'https://drs-api-stg.enphaseenergy.com',
  training_dashboard_url: '/app/training_dashboard',
  bom_ui_url: 'https://bom-stg.enphaseenergy.com',
  bom_api_url: 'https://bom-api-stg.enphaseenergy.com',
  notificationPreferenceUrl: '/app/installer_settings',
  modem_replacement_url: 'https://modem-replacementstg.qa-enphaseenergy.com',
  rma_dashboard_url: 'https://rma-dashboard-rel.qa-enphaseenergy.com',
  temp_generator_token_url: 'https://generator-token-service.enphaseenergy.com',
  HEMS_INTEGRATION: 'https://hems-integration-stg.enphaseenergy.com',
  HEMS_REPLACEMENT_STATUS_POLL_INTERVAL: 5000,
  enphase_url: 'https://enphase.com'
};

const DEFAULT = {};

const CONFIG = {
  development,
  production,
  test,
  qa2,
  qa4,
  dev,
  stg,
  rel,
  cotqa4,
  preprod
};

const getConfig = () => {
  console.log('App running environment is:', window.build_environment);
  const env = window.build_environment;

  let envConfig = CONFIG[env];
  envConfig['env'] = env;
  if (envConfig) {
    return assign({}, DEFAULT, envConfig);
  }
  throw new Error('Unknown environment : ' + env);
};

export const getTempGeneratorTokenConfig = () => {
  return enableTempGeneratorTokenUrl;
};

export default getConfig;
